import { render } from "./userPage.vue?vue&type=template&id=4d9ea9dc&scoped=true"
import script from "./userPage.vue?vue&type=script&lang=js"
export * from "./userPage.vue?vue&type=script&lang=js"

import "./userPage.vue?vue&type=style&index=0&id=4d9ea9dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9ea9dc"]])

export default __exports__